import { generateUtilityClasses } from '@mui/material';

export const checkboxGroupClasses = generateUtilityClasses('CheckboxGroup', ['root', 'option']);
